export default [
  {
    path: '/interface-definition/universalInterface/:id',
    component: () => import('@/app/interface-definition/views/universalInterface'),
    name: 'UniversalInterface',
    meta: { title: '通用接口平台', icon: '', noCache: true, breadcrumb: true ,whiteList: true },
  },
  {
    path: '/interface-definition/index/:id',
    component: () => import('@/app/interface-definition/views/interface-connection'),
    name: 'InterfaceConnection',
    meta: { title: '通用接口平台', icon: '', noCache: true, breadcrumb: true ,whiteList: true },
  },
]
